export class TopologyList {
  toplogyIdOfDefault: string;
  topologiesWithRoots: Array<TopologyWithRoot>;
  constructor(
    toplogyIdOfDefault: string,
    topologiesWithRoots: Array<TopologyWithRoot>) {
    this.toplogyIdOfDefault = toplogyIdOfDefault;
    this.topologiesWithRoots = topologiesWithRoots;
  }
}

export class TopologyWithRoot {
  TopologyId: string
  Type: string
  gridElementId: number
  internalDsoId: string
  lastTopologyChange:string
  latitude: number
  longitude: number
  displayName: string
  constructor(
    TopologyId: string,
    Type: string,
    gridElementId: number,
    internalDsoId: string,
    lastTopologyChange:string,
    latitude: number,
    longitude: number,
    displayName: string) {
    this.TopologyId = TopologyId;
    this.Type = Type;
    this.gridElementId = gridElementId;
    this.internalDsoId = internalDsoId;
    this.lastTopologyChange = lastTopologyChange;
    this.latitude = latitude;
    this.longitude = longitude;
    this.displayName = displayName;
  }
}


export class TopologyConfig {
  topologyId: string
  mapCenterLat: number
  mapCenterLon: number
  lastTopologyChange: string
  constructor(
    topologyId: string,
    mapCenterLat: number,
    mapCenterLon: number,
    lastTopologyChange: string) {
    this.topologyId = topologyId;
    this.mapCenterLat = mapCenterLat;
    this.mapCenterLon = mapCenterLon;
    this.lastTopologyChange = lastTopologyChange;
  }
}
